<div class="grid gap-y-5" style="grid-template-columns: auto 1fr" data-testid="badge-list">
  @for (item of items(); track item.key) {
    <div
      class="min-w-[60px] px-3 bg-third-level rounded-lg flex items-center justify-center h-auto mr-3"
      [attr.data-testid]="'badge-list-card-' + item.key"
    >
      <div class="text-sm" [attr.data-testid]="'badge-list-number-' + item.key">
        {{ item.identifier }}
      </div>
    </div>

    <p-panel
      [toggleable]="isItemOpenable(item)"
      toggler="header"
      [collapsed]="item.collapsed ?? true"
      (collapsedChange)="onCollapsedChange(item, $event)"
      class="flex-1"
      [attr.data-testid]="'badge-list-panel-' + item.key"
    >
      <ng-template #header>
        <div class="flex justify-between items-center w-full min-h-14 gap-10 pr-10">
          <div class="flex-1">
            <div class="flex items-center gap-2 flex-wrap">
              <h3
                class="text-lg font-semibold m-0"
                [attr.data-testid]="'badge-list-title-' + item.key"
              >
                {{ item.translations | translateDirectus }}
              </h3>
              @if (item.badgeTranslations?.length) {
                @let badgeLabel = item.badgeTranslations | translateDirectus;
                <span
                  class="px-2 py-0.5 text-xs font-medium rounded-sm bg-third-level text-secondary"
                  [attr.data-testid]="'badge-list-badge-' + item.key"
                >
                  {{ badgeLabel }}
                </span>
              }
              @let tooltip = item.translations | translateDirectus: 'tooltip' : true;
              @if (tooltip) {
                <app-directus-tooltip [tooltip]="tooltip" />
              }
            </div>
          </div>
          @if (headerInputTemplate(); as headerTemplate) {
            <div
              class="flex items-center gap-2 whitespace-nowrap"
              role="presentation"
              (click)="$event.stopPropagation()"
            >
              <ng-container
                [ngTemplateOutlet]="headerTemplate"
                [ngTemplateOutletContext]="{$implicit: item}"
              ></ng-container>
            </div>
          }
        </div>
      </ng-template>

      @if (isItemOpenable(item)) {
        <ng-template #headericons let-collapsed>
          <i class="pi" [class.pi-chevron-down]="collapsed" [class.pi-chevron-up]="!collapsed"></i>
        </ng-template>

        @if (contentTemplate(); as content) {
          <ng-container
            [ngTemplateOutlet]="content"
            [ngTemplateOutletContext]="{$implicit: item}"
          ></ng-container>
        }
      }
    </p-panel>
  }
</div>
